module.exports = __webpack_public_path__ + "img/metaData.a242005d.svg";